/**
 * contact模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const contact = {
  //查询联系人
  queryContacts(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/contact/queryContacts`,param);
  },
  // 联系人创建
  createContact(params) {
    return $http.post(`${global.API_URL}/sme/contact/create`,params);
  },
  //联系人分页
  pageContact(params) {
    return $http.post(`${global.API_URL}/sme/contact/page`,params);
  },
  //联系人删除
  deleteContact(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/contact/delete`,param);
  },
  //查询联系人日志
  listContactOperationLogByContactGroupId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/contact/listContactGroupOperationLogByContactGroupId`,param);
  },
  //查询联系人
  selectContact(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/contact/select`,param);
  },
  // 根据公司查询联系人
  selectContactListByCompanyId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/contact/selectContactListByCompanyId`,param);
  },
  // 编辑联系人
  updateContact(params) {
    return $http.post(`${global.API_URL}/sme/contact/update`,params);
  },
  // 删除监控模块
  deleteMonitorModule(params) {
    return $http.post(`${global.API_URL}/sme/contact/deleteMonitorModule`,params);
  },
  // 查询在联系人组中的联系人列表
  listContactsInContactGroup(params) {
    return $http.post(`${global.API_URL}/sme/contact/listContactsInContactGroup`,params);
  },
  // 查询不在联系人组中的联系人列表
  listContactsNotInContactGroup(params) {
    return $http.post(`${global.API_URL}/sme/contact/listContactsNotInContactGroup`,params);
  },
  // 查询替换联系人列表
  selectReplaceContactList(params) {
    return $http.post(`${global.API_URL}/sme/contact/selectReplaceContactList`,params);
  },
  // 替换联系人
  replaceContact(params) {
    return $http.post(`${global.API_URL}/sme/contact/replaceContact`,params);
  },
  // 通过账户ID和模块查询通知对象下拉框
  queryContactsByAccountIdAndMonitorModule(params) {
    return $http.post(`${global.API_URL}/sme/contact/queryContactsByAccountIdAndMonitorModule`,params);
  }
}

export default contact;



// WEBPACK FOOTER //
// ./src/api/contact.js